// extracted by mini-css-extract-plugin
export default {"menuBlock":"YH-z","title":"ZH-z","nav":"_H-z","flexCell":"aI-z","facetLink":"bI-z"};